import React, { FC, ReactNode, useState } from 'react';
import styled from 'styled-components';
import { IconArrowDown } from '@lmn/lastminute-react-icons/lastminute-icons-linear';
import { formatLinkStyle } from '../atoms/link-highlight';
import { mediaQuery } from '../utils-css/media-query';

const DropdownLabel = styled.div`
  display: flex;
  flex-direction: row;
  align-self: flex-start;
`;

const Arrow = styled(IconArrowDown)<{ $rotate: boolean }>`
  transition: transform 0.3s;
  transform: rotateX(${(props): string => (props.$rotate ? '180deg' : '0')});
  ${({ theme }): string => theme.mixins.margin({ top: 0.75, right: 0, bottom: 0, left: 1 })}
`;

const DropdownContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 90%;
  overflow: hidden;
  background-color: white;
  border-radius: 3px;
  top: ${({ theme }): string => theme.mixins.spacing(3.5)};
  ${({ theme }): string => theme.mixins.margin({ top: 0, right: 0, bottom: 0, left: 1 })};
  ${({ theme }): string => theme.mixins.padding({ hor: 1, ver: 1 })};

  ${mediaQuery.minWidth.lg} {
    position: absolute;
    width: auto;
    left: 50%;
    transform: translateX(-50%);
    ${({ theme }): string => theme.mixins.margin({ top: 0, right: 0, bottom: 0, left: 0 })};
    ${({ theme }): string => theme.mixins.padding({ hor: 1, ver: 1 })};
  }
`;

const DropdownItem = styled.span`
  ${formatLinkStyle};
  ${({ theme }): string => theme.mixins.padding({ hor: 0, ver: 0 })};
  ${({ theme }): string => theme.mixins.margin({ hor: 2, ver: 1 })};
`;

export const Dropdown: FC<{ label: string; children: ReactNode }> = ({ label, children }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <DropdownItem
      onClick={() => setShowDropdown(!showDropdown)}
      onMouseEnter={() => setShowDropdown(!showDropdown)}
      onMouseLeave={() => setShowDropdown(!showDropdown)}
    >
      <DropdownLabel>
        {label} <Arrow $rotate={showDropdown} />{' '}
      </DropdownLabel>
      {showDropdown && <DropdownContent>{children}</DropdownContent>}
    </DropdownItem>
  );
};
